/**
 * Formats a stored copywriting-framework name (snake_case, e.g. "trigger_followup")
 * into a display label ("Trigger Followup"). Display-only — stored names stay
 * untouched because they are used as matching keys (effectiveness lookups, AI prompts).
 */
export const formatFrameworkName = (name: string): string => {
	return name
		.split(/[_\s]+/)
		.filter(Boolean)
		.map((word) =>
			// Capitalize all-lowercase words; keep intentional casing (e.g. "iPhone", "AI") as-is.
			word === word.toLowerCase() ? word.charAt(0).toUpperCase() + word.slice(1) : word
		)
		.join(" ");
};
